// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style-module--wrapper--3D66m","content":"style-module--content--1jUZW","number":"style-module--number--ICKnt","closeIcon":"style-module--closeIcon--3ofAB"};